const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "https://localhost:7219"
    // : "https://marmorex-backend-e4a7faefegcae2ch.westeurope-01.azurewebsites.net";
    : "https://api.marmorex.ro";

export default API_BASE_URL;
